var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39996 3.20848V0.210977C5.81613 0.371035 6.19434 0.619395 6.50927 0.939727L8.07716 2.53752C8.39187 2.85785 8.63592 3.24285 8.79307 3.66695H5.85009C5.60161 3.66695 5.40017 3.46178 5.40017 3.20869L5.39996 3.20848ZM9 4.80563V8.70826C8.99852 9.97326 7.99194 10.9985 6.74995 11H2.25005C1.00806 10.9985 0.00147655 9.97326 0 8.70826V2.29174C0.00147655 1.02674 1.00806 0.00150391 2.25005 0H4.28179C4.35519 0 4.42754 0.00601561 4.5001 0.010957V3.20826C4.5001 3.96773 5.10444 4.58326 5.85009 4.58326H8.98924C8.99409 4.65695 9 4.73086 9 4.80563ZM5.39996 8.70848C5.39996 8.45539 5.19851 8.25022 4.95003 8.25022H2.69998C2.4515 8.25022 2.25005 8.45539 2.25005 8.70848C2.25005 8.96156 2.4515 9.16674 2.69998 9.16674H4.95003C5.19851 9.16674 5.39996 8.96156 5.39996 8.70848ZM6.74995 6.875C6.74995 6.62191 6.5485 6.41674 6.30002 6.41674H2.69998C2.4515 6.41674 2.25005 6.62191 2.25005 6.875C2.25005 7.12809 2.4515 7.33326 2.69998 7.33326H6.30002C6.5485 7.33326 6.74995 7.12809 6.74995 6.875Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumento);
export default __webpack_public_path__ + "static/media/documento.df6d8b81e96d26f96bb06f8f09dcfb5f.svg";
export { ForwardRef as ReactComponent };